angular.module('bribac.entities.mainGroupFactory', [])

  .value('mainGroupFactory', function mainGroupFactory(data) {
    return angular.merge({
      id: null,
      name: null,
      subGroups: []
    }, data)
  })
